import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPatientNameForDisplay } from '../utils/patientNameUtils';

const PatientInfoHeader = ({
    patientFirstName = '',
    patientLastName = '',
    patientNameFallback = '',
    patientId = '',
    lengthType = '',
    compressionClass = '',
    knitting = '',
    measurementType = '',
    children = null,
}) => {
    const { t } = useTranslation();

    return (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800 mb-2">
                <strong>{t('measurements.stockingSelection.patientLabel')}:</strong>{' '}
                {patientFirstName || patientLastName
                    ? formatPatientNameForDisplay(patientFirstName, patientLastName, patientNameFallback)
                    : patientNameFallback}{' '}
                (ID: {patientId || t('measurements.stockingSelection.notAvailable')})
            </p>

            <p className="text-sm text-blue-800">
                {measurementType && (
                    <>
                        <span className="font-semibold">{t(`measurements.legMeasuring.measurementType.${measurementType}`)}</span>
                        {(lengthType || compressionClass || knitting) && ' - '}
                    </>
                )}
                {lengthType && `${lengthType} (${t(`measurements.lengthType.${lengthType}`)})`}
                {lengthType && compressionClass && ' - '}
                {compressionClass && t(`measurements.compressionClass.${compressionClass}`)}
                {(lengthType || compressionClass) && knitting && ' - '}
                {knitting && t(`measurements.knitting.${knitting}`)}
            </p>

            {children}
        </div>
    );
};

export default PatientInfoHeader;
